export default "__VITE_ASSET__DrC3LOP8__"